// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1Mq-f","approved":"Status_approved__MsOvl","rejected":"Status_rejected__9N_EW","expired":"Status_expired__1DiND","label":"Status_label__2Cvdi"};